import { type FC } from 'react'

import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { DeviceVariantRadioOption } from 'modules/it_management/components/device_catalog/DeviceVariantSelector/types'
import { F0Text } from '@factorialco/f0-react'

export interface DeviceVariantRadioProps {
  variant: DeviceVariantRadioOption
  value?: string
  onChange: (value: string) => void
}

const RadioButton = ({
  id,
  label,
  description,
  selected,
  value,
  onChange,
}: {
  id: string
  label: string
  description: string
  selected: boolean
  value: string
  onChange: (value: string) => void
}) => {
  return (
    <div
      className="flex flex-row items-center justify-between p-3 cursor-pointer w-full rounded"
      style={{
        border: `1px solid ${selected ? 'var(--color-group7)' : 'var(--color-grey400)'}`,
        backgroundColor: selected
          ? 'color-mix(in srgb, var(--color-group7) 10%, transparent)'
          : 'transparent',
      }}
      onClick={() => onChange(value)}
    >
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <F0Text variant="label" content={label} />
        {description && <F0Text ellipsis variant="small" content={description} />}
      </div>

      <div
        className="flex flex-row items-center justify-center flex-none rounded-full"
        style={{
          width: '20px',
          height: '20px',
          backgroundColor: selected ? 'var(--color-group7)' : 'white',
        }}
      >
        {selected && <div className="h-2 w-2 rounded-full bg-white" />}
      </div>
    </div>
  )
}

export const DeviceVariantRadio: FC<DeviceVariantRadioProps> = ({ variant, value, onChange }) => {
  return (
    <div className="flex flex-col">
      <SectionHeader title={variant.title} description={''} />
      <div className="flex flex-col gap-2">
        {variant.variants.map((option) => {
          const isSelected = option.id === value

          return (
            <RadioButton
              key={option.id}
              id={`${variant.id}-${option.id}`}
              label={option.name}
              description={option.description || ''}
              selected={isSelected}
              value={option.id}
              onChange={onChange}
            />
          )
        })}
      </div>
    </div>
  )
}
